var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{fill:#fff;}.c{filter:url(#b);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.891,
    y1: 0.172,
    x2: 0.178,
    y2: 0.837,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7024c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335,
    stopColor: "#c21975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#c74c4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e09b3d"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 4,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "c"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "c"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.83 5)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "matrix(1, 0, 0, 1, -6.83, -5)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 21,
    cy: 21,
    r: 21,
    transform: "translate(7 5)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M14.744,21H6.256A6.263,6.263,0,0,1,0,14.744V6.256A6.263,6.263,0,0,1,6.256,0h8.488A6.263,6.263,0,0,1,21,6.256v8.488A6.263,6.263,0,0,1,14.744,21ZM6.256,2.112A4.148,4.148,0,0,0,2.112,6.256v8.488a4.148,4.148,0,0,0,4.144,4.143h8.488a4.148,4.148,0,0,0,4.143-4.143V6.256a4.148,4.148,0,0,0-4.143-4.144ZM10.5,15.931A5.431,5.431,0,1,1,15.931,10.5,5.437,5.437,0,0,1,10.5,15.931Zm0-8.75A3.319,3.319,0,1,0,13.819,10.5,3.322,3.322,0,0,0,10.5,7.181Zm5.442-.77a1.3,1.3,0,1,1,1.3-1.3A1.3,1.3,0,0,1,15.942,6.411Z",
    transform: "translate(11.17 11)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.b1e83b6e1c326779469bf078107da0aa.svg";
export { ForwardRef as ReactComponent };